import { API } from "@/lib/api";
import { APIService, FetchListRequest } from "@/services/api";
import { ReadLaborCostsInStoresInitialDepartmentBased } from "@/types/laborCostsInStoresInitial";

const LaborCostsInStoresInitialDepartmentBasedServiceAPI =
  new APIService<ReadLaborCostsInStoresInitialDepartmentBased>(
    API.InvoiceSpecifications,
  );

export const laborCostsInStoresInitialDepartmentBased = {
  getList: (
    settlementId: string,
    fetchParams?: FetchListRequest<ReadLaborCostsInStoresInitialDepartmentBased>,
  ) =>
    LaborCostsInStoresInitialDepartmentBasedServiceAPI.getList(
      fetchParams,
      `/initial/department-based-project/${settlementId}`,
    ),
};

export const laborCostsInStoresDepartmentBased = {
  getList: (
    settlementId: string,
    fetchParams?: FetchListRequest<ReadLaborCostsInStoresInitialDepartmentBased>,
  ) =>
    LaborCostsInStoresInitialDepartmentBasedServiceAPI.getList(
      fetchParams,
      `/${settlementId}/stores`,
    ),
};
